import { takeEvery, all, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import usuarioService from '../../../commons/services/usuario';
import { types, actions } from './actions';
import { formatCep } from '../../../commons/validation/validation';

function* getUsers({ payload }) {
	yield put(actions.handleLoading({ search: true }));

	yield call(delay, 750);
	try {
		let res = yield call(usuarioService.getUsers, payload);
		const listWithFixedCep = res.list.map(user => {
			return { ...user, cep: formatCep(String(user.cep)) };
		});
		res.list = listWithFixedCep;

		yield put(actions.searchUsers.receive(res));
	} catch (err) {
	} finally {
		yield put(actions.handleLoading({ search: false }));
	}
}

function* editProfileUser({ payload }) {
	try {
		yield call(usuarioService.edit, payload);
		yield put(actions.showMsgSuccessEdit(true));
		yield call(delay, 2000);
		yield put(actions.editProfileUser.receive());
	} catch (err) {
		yield put(actions.editProfileUser.error(err.response.data.message));
	} finally {
		yield put(actions.showMsgSuccessEdit(false));
	}
}

export default function* root() {
	yield all([
		takeEvery(types.SEARCH_USERS.REQUEST, getUsers),
		takeEvery(types.EDIT_PROFILE_USER.REQUEST, editProfileUser)
	]);
}
